import { logger } from '@tunasong/models'
import { profilesApi } from '@tunasong/redux'
import type { TunaThunkDispatch } from '@tunasong/redux'
import type { BandPartsInfo } from './stage-setup.js'

/**
 * The parts each member plays in a band and who does not perform with it, for generate and sync.
 * A failed request yields `undefined`: the caller then includes everyone with their free-text role, never blocks.
 */
export const loadBandPartsInfo = async (
  dispatch: TunaThunkDispatch,
  bandId: string
): Promise<BandPartsInfo | undefined> => {
  const result = await dispatch(profilesApi.endpoints.loadBandParts.initiate({ bandId }))
  if (result.error || !result.data) {
    logger.warn('Could not load band parts; generating without parts or opt-outs', { bandId, error: result.error })
    return undefined
  }
  return { parts: result.data.parts, notPerforming: result.data.notPerforming ?? [] }
}
